/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from "react";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";

import { tabStyles } from "./courseStyles";
import TopBar from "./Components/TopBar/TopBar";
import Courses from "./Components/Courses/Courses";
import Inquiries from "./Components/Inquiries/Inquiries";
import Purchases from "./Components/Purchases/Purchases";
import CourseFormModal from "./Components/CourseForm/CourseFormModal";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`course-tabpanel-${index}`}
      aria-labelledby={`course-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node.isRequired,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const a11yProps = (index) => ({
  id: `course-tab-${index}`,
  "aria-controls": `course-tabpanel-${index}`,
});

const Course = () => {
  const classes = tabStyles();
  const [value, setValue] = useState(0);
  const [actionPerformed, setActionPerformed] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [courseSearch, setCourseSearch] = useState("");
  const [purchaseSearch, setPurchaseSearch] = useState("");
  const [formOpen, setFormOpen] = useState(false);
  const [editingCourse, setEditingCourse] = useState(null);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const onCreateClick = () => {
    setEditingCourse(null);
    setFormOpen(true);
  };

  const handleEditCourse = (course) => {
    setEditingCourse(course);
    setFormOpen(true);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static" className={classes.tabBar}>
        <Tabs
          TabIndicatorProps={{ style: { background: "black", height: "2px" } }}
          className={classes.tabBox}
          value={value}
          onChange={handleChange}
          aria-label="course tabs"
        >
          <Tab className={classes.tabValue} label="Courses" {...a11yProps(0)} />
          <Tab className={classes.tabValue} label="Inquiries" {...a11yProps(1)} />
          <Tab
            className={classes.tabValue}
            label="Course Purchases"
            {...a11yProps(2)}
          />
        </Tabs>
      </AppBar>

      {!errorMsg && (
        <TopBar
          value={value}
          searchQuery={value === 0 ? courseSearch : purchaseSearch}
          setSearchQuery={value === 0 ? setCourseSearch : setPurchaseSearch}
          onCreateClick={onCreateClick}
        />
      )}

      <Box className={classes.paddingAll}>
        <TabPanel value={value} index={0}>
          <Courses
            searchQuery={courseSearch}
            errorMsg={errorMsg}
            setErrorMsg={setErrorMsg}
            actionPerformed={actionPerformed}
            setActionPerformed={setActionPerformed}
            handleEditCourse={handleEditCourse}
          />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Inquiries
            errorMsg={errorMsg}
            setErrorMsg={setErrorMsg}
            actionPerformed={actionPerformed}
            setActionPerformed={setActionPerformed}
          />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <Purchases
            searchQuery={purchaseSearch}
            errorMsg={errorMsg}
            setErrorMsg={setErrorMsg}
            actionPerformed={actionPerformed}
            setActionPerformed={setActionPerformed}
          />
        </TabPanel>
      </Box>

      {formOpen && (
        <CourseFormModal
          open={formOpen}
          course={editingCourse}
          handleClose={() => setFormOpen(false)}
          handleOnSuccess={() => setActionPerformed(true)}
        />
      )}
    </div>
  );
};

export default Course;
